module.exports = __webpack_public_path__ + "img/trouble.94d575a6.svg";